import React from "react"
import styles from "./styles.scss"
import laptop from "images/hero-laptop.png"
import rotatedLaptop from "images/hero-laptop-rotated.png"
import rotatedLaptopFallback from "images/hero-laptop-rotated-fallback.png"
import posed, { PoseGroup } from "react-pose"
import cx from "classnames"
import { detect } from "detect-browser"

const browser = detect()

const AnimatedImage = posed.div({
  enter: { opacity: 1 },
  exit: { opacity: 0 },
})

class Previews extends React.PureComponent {
  state = { x: 10, y: 0 }

  componentWillReceiveProps(nextProps) {
    if (browser.name === "ie") return

    if (nextProps.visible)
      return document.addEventListener("mousemove", this.handleMove, true)

    document.removeEventListener("mousemove", this.handleMove, true)
  }

  componentWillUnmount = () => {
    if (browser.name === "ie") return
    document.removeEventListener("mousemove", this.handleMove, true)
  }

  handleMove = ({ clientX, clientY }) =>
    this.setState({ x: clientX, y: clientY })

  render() {
    const { x, y } = this.state
    const { backgroundImage } = this.props

    const showFallbackImage = browser.name === "ie" || browser.name === "edge"

    return (
      <div className={styles.container}>
        <div
          style={{
            backgroundImage: `url(${
              showFallbackImage ? rotatedLaptopFallback : rotatedLaptop
            })`,
            transform: `translate(${x / 50 + 150}px, ${y / 45}px)`,
          }}
          className={cx(styles.computer, styles.tiltedComputer)}
        >
          {!showFallbackImage && (
            <PoseGroup>
              <AnimatedImage
                key={backgroundImage}
                className={styles.backgroundImageContainer}
              >
                <img
                  src={backgroundImage}
                  alt="Roterad laptop med aktiv case study som bakgrundsbild."
                  className={cx(styles.background, styles.tiltedBackground)}
                />
              </AnimatedImage>
            </PoseGroup>
          )}
        </div>
        <div
          style={{
            backgroundImage: `url(${laptop})`,
            transform: `translate(${x / 40 - 100}px, ${y / 30}px)`,
          }}
          className={cx(styles.computer, styles.straightComputer)}
        >
          <PoseGroup>
            <AnimatedImage
              key={backgroundImage}
              className={styles.backgroundImageContainer}
            >
              <img
                src={backgroundImage}
                alt="Laptop med aktiv case study som bakgrundsbild."
                className={cx(styles.background, styles.straightBackground)}
              />
            </AnimatedImage>
          </PoseGroup>
        </div>
      </div>
    )
  }
}

export default Previews



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Hero/Previews/index.jsx